// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3tt2s","header":"MergedInvoice_header__bXtjl"};